import React from 'react';
import styles from './styles.module.css';
import { useAuthFileUrl } from './AuthFile';
import { getKindIcon, getKindInfo, isImageKind } from './attachmentKinds';

/**
 * Miniatura de um anexo. Imagens são baixadas pelo endpoint autenticado
 * (shimmer enquanto carrega); PDF/documento mostram o ícone do tipo.
 *
 * @param {object} attachment linha do anexo
 * @param {number} size lado da miniatura em px
 * @param {string} chipLabel rótulo opcional sobre a miniatura
 * @param {function} onClick
 */
const AttachmentThumb = ({ attachment, size = 56, chipLabel, onClick }) => {
    const isImage = attachment && isImageKind(attachment.kind);
    const fileSize = attachment && attachment.thumbFileName ? 'thumb' : 'full';
    const { url, loading } = useAuthFileUrl(attachment ? attachment.id : null, fileSize, !!isImage);

    const kindInfo = getKindInfo(attachment ? attachment.kind : null);

    const classNames = [
        styles.thumb,
        onClick ? styles.thumbClickable : '',
        isImage && (loading || !url) ? styles.thumbLoading : ''
    ].filter(Boolean).join(' ');

    return (
        <div
            className={classNames}
            style={{
                width: size,
                height: size,
                backgroundColor: isImage ? undefined : kindInfo.background
            }}
            onClick={onClick}
            title={attachment ? (attachment.title || attachment.originalName) : ''}
        >
            {isImage
                ? (url && <img className={styles.thumbImage} src={url} alt={attachment.title || attachment.originalName || 'Anexo'} />)
                : getKindIcon(attachment ? attachment.kind : null, Math.round(size * 0.45))
            }

            {chipLabel && <span className={styles.thumbChip}>{chipLabel}</span>}
        </div>
    );
};

export default AttachmentThumb;
